import { StepLogger } from "analytics/funnel";
import { History } from "history";
import L10n from "localization";
import GenFlashcardsNav from "./genFlashcardsNav";
import { OnboardingGoalInfo } from "./onboardingModal";
import SingleSelectNav, { IPromptOption } from "./singleSelectNav";

interface IProps {
  dismiss: () => Promise<void>;
  onAddToInbox: () => void;
  history: History;
  logStep: StepLogger;
  subject: string;
  subjectName: string;
  gradeLevel: string;
}
export default function GoalSchoolVectorNav(props: IProps) {
  const opts: IPromptOption[] = [
    { name: L10n.localize((s) => s.general.none), val: "none" },
    { name: L10n.localize((s) => s.onboarding.durationLessThan1Year), val: "< 1 year" },
    { name: L10n.localize((s) => s.onboarding.duration2Years), val: "2 years" },
    { name: L10n.localize((s) => s.onboarding.duration3Years), val: "3 years" },
    { name: L10n.localize((s) => s.onboarding.durationMoreThan3Years), val: "> 3 years" },
  ];
  return (
    <SingleSelectNav
      title={props.subjectName}
      description={L10n.localize((s) => s.onboarding.learningVectorDescription)}
      options={opts}
      dismiss={props.dismiss}
      history={props.history}
      onNav={(opt) => {
        const goal: OnboardingGoalInfo = {
          goal: "school",
          subject: props.subject,
          priorStudy: opt.val,
        };
        const prompt = `Context: User is a student who wants flashcards to help them learn their subject of study.
Subject: ${props.subject}.
Grade level: ${props.gradeLevel}
Previous amount of study: ${opt.val}`;
        return (
          <GenFlashcardsNav
            prompt={prompt}
            dismiss={props.dismiss}
            history={props.history}
            onAddToInbox={props.onAddToInbox}
            logStep={props.logStep}
            goal={goal}
          />
        );
      }}
    />
  );
}
